define('shared/lib/SecondLevelDomains',[],function () {
    return null;
});
